module.exports = __webpack_public_path__ + "img/album19_08.3af54631.jpg";